import React from 'react';
import { t } from '../../../modules/infra/i18n';

const Success = () => (
  <div className="c-handoff-bar c-handoff-bar_success">
    <span className="u-fontsize-tiny u-type--bold u-co-white">{t('shops:handoff.success_message')}</span>
  </div>
);

export default Success;
